import { render, staticRenderFns } from "./MeetingStudent.vue?vue&type=template&id=50606ace&"
import script from "./MeetingStudent.js?vue&type=script&lang=js&"
export * from "./MeetingStudent.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports